import { UserSettingsActions, UserSettingsActionTypes } from './actionTypes';
import { ActionCreator, Dispatch } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { apiClient } from '../../services/apiService';
import { IUserSettingsState } from './store';
import { AccountSettings, UserSettings } from './types';
import { AccountConfig } from '@skf/bt-wind-rail-commonlibrary/dist/types/AccountPageData';

export const fetchUserSettings: ActionCreator<ThunkAction<
  Promise<any>,
  IUserSettingsState,
  null,
  UserSettingsActions
>> = () => {
  return async (dispatch: Dispatch<UserSettingsActions>) => {
    console.log('action fetch user settings fron thunk action!!');
    dispatch({
      type: UserSettingsActionTypes.FETCH_USER_SETTINGS_REQUEST,
      status: 200,
      isFetching: true,
    });
    try {
      const response = await apiClient.get<UserSettings>(
        `/api/usersmanagement/users/settings`
      );
      dispatch({
        type: UserSettingsActionTypes.FETCH_USER_SETTINGS_SUCCESS,
        status: 200,
        userSettings: response.data,
        isFetching: false,
      });
    } catch (err) {
      dispatch({
        type: UserSettingsActionTypes.FETCH_USER_SETTINGS_ERROR,
        status: 500,
        isFetching: false,
      });
    }
  };
};

export const fetchAccountSettings: ActionCreator<ThunkAction<
  Promise<any>,
  IUserSettingsState,
  null,
  UserSettingsActions
>> = () => {
  return async (dispatch: Dispatch<UserSettingsActions>) => {
    try {
      dispatch({
        type: UserSettingsActionTypes.FETCH_ACCOUNT_SETTINGS_REQUEST,
        isFetching: true,
        status: 200,
      });
      const response = await apiClient.get<AccountSettings>(
        `/api/usersManagement/userSettings/settings/profile`
      );
      dispatch({
        type: UserSettingsActionTypes.FETCH_ACCOUNT_SETTINGS_SUCCESS,
        isFetching: false,
        status: 200,
        accountSettings: response.data,
      });
    } catch (err) {
      dispatch({
        type: UserSettingsActionTypes.FETCH_USER_SETTINGS_ERROR,
        isFetching: false,
        status: 500,
      });
    }
  };
};

export const putAccountSettings: ActionCreator<ThunkAction<
  Promise<any>,
  IUserSettingsState,
  null,
  UserSettingsActions
>> = (
  accountConfig: AccountConfig,
  okCallback: () => void,
  failedCallback: () => void
) => {
  return async (dispatch: Dispatch<UserSettingsActions>) => {
    try {
      dispatch({
        type: UserSettingsActionTypes.POST_ACCOUNT_SETTINGS_REQUEST,
        isFetching: true,
      });
      const response = await apiClient.put<boolean>(
        `/api/usersManagement/userSettings/settings/profile`,
        accountConfig
      );
      dispatch({
        type: UserSettingsActionTypes.POST_ACCOUNT_SETTINGS_SUCCESS,
        isFetching: false,
        status: 200,
      });
      okCallback();
    } catch (err) {
      dispatch({
        type: UserSettingsActionTypes.POST_ACCOUNT_SETTINGS_ERROR,
        isFetching: false,
        status: 500,
      });
      failedCallback();
    }
  };
};
